<template>
  <section v-show="records && (records.length > 0)">
    <h2 class="mx0 my1">Fundamentação Doutrinária (apostila)</h2>
    <div class="h3 my1" v-for="(record, index) in records" :key="index">
      <p>
        {{record.CONTEUDO}}
      </p>
    </div>
  </section>
</template>

<script>
var componentDefinition = {
  props: ['records']
}
export default componentDefinition
</script>
